export default [
	'multiple_choice',
	'new_multiple_choice'
]
